import { TimelineSegmentDataBase, TimelineSegmentContentDataBase } from '../ScattData.js';

class PlaybackHistoryData extends TimelineSegmentContentDataBase {
  static UncombinableError = class extends Error{};

  constructor(date = new Date()) {
    super();
    this.date = date;
  }

  static generateFromRawObj(playbackHistoryDataRawObj) {
    return new this(new Date(playbackHistoryDataRawObj['date']))
  }

  generateRawObj() {
    let playbackHistoryDataRawObj = {};
    playbackHistoryDataRawObj['date'] = this.date.toISOString();
    return playbackHistoryDataRawObj;
  }

  clone() {
    return new this.constructor(new Date(this.date.getTime()));
  }

  isSameAs(that) {
    if (this.date.getTime() !== that.date.getTime()) return false;
    return true;
  }

  /* eslint-disable no-unused-vars */
  combine(that) {
    throw new PlaybackHistoryData.UncombinableError('Playback history is uncombinable');
  }
  /* eslint-enable no-unused-vars */
}

class PlaybackHistorySegmentData extends TimelineSegmentDataBase {
  static contentData = PlaybackHistoryData;

  constructor(begin, end, playbackHistoryData, isLocked) {
    super(begin, end, playbackHistoryData, isLocked);
  }

  static toString() {
    return 'PlaybackHistorySegmentData';
  }

  static get name() {
    return 'Playback History Data';
  }

  clone() {
    return super.clone(false);
  }
}

export default PlaybackHistorySegmentData;
